import React from "react";
import PropTypes from "prop-types";
import Clickable from "./Clickable";
import { PER_PAGE_OPTIONS } from "./usePaymentRequestQuery";

/**
 * Thanh phân trang cuối bảng — "rows per page" bên trái, điều hướng bên phải
 * (học layout footer của HR Hub: system/users + document recipients modal).
 *
 * `pagination` là pagination_meta do BE trả về; nếu chưa có thì không render gì
 * (tránh nháy một thanh rỗng trong lúc load lần đầu).
 */
const BTN = "tw-inline-flex tw-items-center tw-justify-center tw-w-7 tw-h-7 tw-rounded-geist-sm tw-border tw-border-solid tw-border-geist-border tw-bg-geist-bg tw-text-geist-fg-2 hover:tw-bg-geist-100 hover:tw-text-geist-fg tw-transition-colors";
const BTN_OFF = "tw-inline-flex tw-items-center tw-justify-center tw-w-7 tw-h-7 tw-rounded-geist-sm tw-border tw-border-solid tw-border-geist-border tw-bg-geist-bg-2 tw-text-geist-fg-3 tw-cursor-default";

const Pagination = ({ pagination, perPage, onPageChange, onPerPageChange }) => {
  if (!pagination) return null;

  const { current_page: page = 1, total_pages: totalPages = 1, total_rows: totalRows = 0 } = pagination;
  const first = page <= 1;
  const last = page >= totalPages;

  const go = (target) => () => {
    if (target >= 1 && target <= totalPages && target !== page) onPageChange(target);
  };

  return (
    <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3 tw-px-4 tw-py-2.5 tw-border-t tw-border-solid tw-border-geist-border tw-bg-geist-bg-2">
      <label className="tw-flex tw-items-center tw-gap-2 tw-text-[11px] tw-text-geist-fg-3 tw-m-0">
        Rows per page
        <select
          value={perPage}
          onChange={(e) => onPerPageChange(Number(e.target.value))}
          className="tw-h-7 tw-rounded-geist-sm tw-border tw-border-solid tw-border-geist-border tw-bg-geist-bg tw-px-1.5 tw-text-[11px] tw-text-geist-fg focus:tw-border-geist-accent focus:tw-outline-none"
        >
          {PER_PAGE_OPTIONS.map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
      </label>

      <div className="tw-flex tw-items-center tw-gap-3">
        <span className="tw-text-[11px] tw-text-geist-fg-3 tw-tabular-nums">
          {totalRows.toLocaleString("en-US")} total · page {page}/{totalPages || 1}
        </span>
        <div className="tw-flex tw-items-center tw-gap-1">
          <Clickable onClick={go(1)} disabled={first} title="First page" className={first ? BTN_OFF : BTN}>
            <i className="bi bi-chevron-double-left tw-text-[10px]" />
          </Clickable>
          <Clickable onClick={go(page - 1)} disabled={first} title="Previous page" className={first ? BTN_OFF : BTN}>
            <i className="bi bi-chevron-left tw-text-[10px]" />
          </Clickable>
          <Clickable onClick={go(page + 1)} disabled={last} title="Next page" className={last ? BTN_OFF : BTN}>
            <i className="bi bi-chevron-right tw-text-[10px]" />
          </Clickable>
          <Clickable onClick={go(totalPages)} disabled={last} title="Last page" className={last ? BTN_OFF : BTN}>
            <i className="bi bi-chevron-double-right tw-text-[10px]" />
          </Clickable>
        </div>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  pagination: PropTypes.shape({
    current_page: PropTypes.number,
    total_pages: PropTypes.number,
    total_rows: PropTypes.number,
  }),
  perPage: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
  onPerPageChange: PropTypes.func.isRequired,
};

export default Pagination;
